import { DeliveryDate } from '@delivery/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { DeliveryState, StateWithDelivery } from '../delivery-state';
import { getDeliveryState } from './state.selectors';

export const getDeliveryDateState: MemoizedSelector<
  StateWithDelivery,
  StateUtils.LoaderState<DeliveryDate>
> = createSelector(getDeliveryState, (state: DeliveryState) => state.deliveryDate);

export const getDeliveryDateValue: MemoizedSelector<StateWithDelivery, DeliveryDate> = createSelector(
  getDeliveryDateState,
  (state: StateUtils.LoaderState<DeliveryDate>) => StateUtils.loaderValueSelector(state),
);

export const getDeliveryDateLoading: MemoizedSelector<StateWithDelivery, boolean> = createSelector(
  getDeliveryDateState,
  (state: StateUtils.LoaderState<DeliveryDate>) => StateUtils.loaderLoadingSelector(state),
);

export const getDeliveryDateError: MemoizedSelector<StateWithDelivery, boolean> = createSelector(
  getDeliveryDateState,
  (state: StateUtils.LoaderState<DeliveryDate>) => StateUtils.loaderErrorSelector(state),
);

export const getDeliveryDateSuccess: MemoizedSelector<StateWithDelivery, boolean> = createSelector(
  getDeliveryDateState,
  (state: StateUtils.LoaderState<DeliveryDate>) => StateUtils.loaderSuccessSelector(state),
);
